$(document).ready(function () {
  // Initialize first slider
  function initializeSlickWhatWeDo() {
    $(".art-consultation-list .row").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "30px",
          },
        },
      ],
    });
  }

  function destroySlickWhatWeDo() {
    if ($(".art-consultation-list .row").hasClass("slick-initialized")) {
      $(".art-consultation-list .row").slick("unslick");
    }
  }

  function checkWidth() {
    if ($(window).width() <= 768) {
      initializeSlickWhatWeDo();
    } else {
      destroySlickWhatWeDo();
    }
  }

  // Initialize second slider
  var $slickSlider = $(".slick-slider");

  $slickSlider.slick({
    autoplay: false,
    infinite: false,
    speed: 1000,
    autoplaySpeed: 2000,
    prevArrow: '<button class="slide-arrow prev-arrow"></button>',
    nextArrow: '<button class="slide-arrow next-arrow"></button>',
  });

  function updateArrowStates() {
    var currentSlide = $slickSlider.slick("slickCurrentSlide");
    var totalSlides = $slickSlider.slick("getSlick").slideCount - 1;
    if (currentSlide === 0) {
      $(".prev-arrow").addClass("disabled").attr("disabled", true);
    } else {
      $(".prev-arrow").removeClass("disabled").removeAttr("disabled");
    }

    // Disable the next arrow if on the last slide
    if (currentSlide === totalSlides) {
      $(".next-arrow").addClass("disabled").attr("disabled", true);
    } else {
      $(".next-arrow").removeClass("disabled").removeAttr("disabled");
    }
  }

  // Initial check on page load
  updateArrowStates();

  // Check after every slide change
  $slickSlider.on("afterChange", function (event, slick, currentSlide) {
    updateArrowStates();
  });

  // Run width check on document ready and window resize
  checkWidth();
  $(window).resize(function () {
    checkWidth();
  });
});

// Card section annimation

// $(document).ready(function () {
//   gsap.set(".card-stagger-animation", {
//     y: 100,
//     opacity: 0,
//   });

//   gsap.to(".card-stagger-animation", {
//     y: 0,
//     opacity: 1,
//     stagger: 0.5,
//     scrollTrigger: {
//       trigger: ".card-stagger-animation",
//       start: "top-=25% 80%",

//       markers: false,
//       toggleActions: "play none none reverse",
//       onEnter: function () {
//         gsap.to(this.trigger, {
//           y: 0,
//           opacity: 1,
//           stagger: 0.5,
//           duration: 1,
//         });
//       },
//       onLeaveBack: function () {
//         gsap.to(this.trigger, {
//           y: 100,
//           opacity: 0,
//           stagger: 0.5,
//           duration: 1.5,
//         });
//       },
//     },
//   });
// });

// $(document).ready(function () {
//   const imgLeft = gsap.utils.toArray(".animate-img-left");
//   imgLeft.forEach((img) => {
//     gsap.from(img, {
//       x: 100,
//       duration: 1,
//       stagger: 0.3,
//       scrollTrigger: {
//         trigger: img.parentElement, // Corrected reference
//         start: "top center+=30%",
//         end: "bottom center",
//         scrub: true,
//         markers: false,
//       },
//     });
//   });
// });
